export default (state, getters) => (cartID) => {
  let foundedItems = state.waitingInquiries.filter(inquiry => inquiry.cart_id === cartID && inquiry.status === 1);

  if (foundedItems.length) {
    return true;
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/store/getters/global/cartIsWaitingForDecision.js